import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Lato\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"100\",\"300\",\"400\",\"700\",\"900\"],\"style\":[\"normal\",\"italic\"],\"variable\":\"--font-lato\"}],\"variableName\":\"latoFont\"}");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppInsightsErrorBoundary"] */ "/app/src/components/observability/app-insights-error-boundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppInsightsProvider"] */ "/app/src/components/observability/app-insights-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppInsightsUserContext"] */ "/app/src/components/observability/app-insights-user-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitalsReporter"] */ "/app/src/components/observability/web-vitals-reporter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegister"] */ "/app/src/components/pwa/sw-register.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/app/src/components/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/app/src/contexts/settings-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/app/src/providers/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModeProvider"] */ "/app/src/providers/mode-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressProvider"] */ "/app/src/providers/progress-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/app/src/providers/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/providers/theme-provider.tsx");
